
// function chart(){
//     console.log(Chart.defaults.plugins.tooltip.enabled)
//     if(document.querySelector('#ctx')){
//     var ctx = document.querySelector('#ctx').getContext( '2d' );
//     const animation = {
//         x: {
//             duration: 1,
//         },
//         y: {
//             duration: 1,
//         }
//     };

//     const data = [104, 125, 260, 275, 391, 600, 600, 200];

//     var myChart = new Chart(ctx, {
//         type: 'line',
//         data: {
//             labels: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'],
//             datasets: [{
//                 label: 'LINE 1',
//                 data,
//                 borderColor: ['rgba(45,175,230,0)'],
//                 pointBackgroundColor: '#fff',
//                 borderWidth: (window.matchMedia("(max-width: 570px)").matches) ? 1 : 3,
//                 pointBorderWidth: (window.matchMedia("(max-width: 570px)").matches) ? 1 : 3,
//                 pointRadius: (window.matchMedia("(max-width: 570px)").matches) ? 3 : 6
//             }],
//         },
//         options: {
//             animation,
//             responsive: true,
//             plugins: {
//                 legend: {
//                     display: false,
//                 },
//                 tooltips: {
//                     enabled: false
//                 },
//             },
//             scales: {
//                 y: {
//                     beginAtZero: true,
//                     display: false,
//                     suggestedMax: 650,
//                     ticks: {
//                         color: '#166',
//                     }
//                 },
//                 x:{
//                     grid:{
//                         display: false,
//                     },
//                     ticks: {
//                         font:{
//                             size: (window.matchMedia("(max-width: 570px)").matches) ? 10 : 18,
//                         } 
//                     }
//                 },
                
//             },
//         },
//         plugins: [{
//             afterDatasetsDraw: function(chart) {
//                 var ctx = chart.ctx;
//                 chart.data.datasets.forEach(function(dataset, index) {
//                     var datasetMeta = chart.getDatasetMeta(index);
//                     if (datasetMeta.hidden) return;
//                     datasetMeta.data.forEach(function(point, index) {
//                         var value = dataset.data[index],
//                             x = point.getCenterPoint().x,
//                             y = point.getCenterPoint().y,
//                             radius = point.options.radius,
//                             fontSize = (window.matchMedia("(max-width: 570px)").matches) ? 8 : 14,
//                             fontFamily = 'Verdana',
//                             fontColor = 'black',
//                             fontStyle = 'normal';
//                         ctx.save();
//                         ctx.textBaseline = 'middle';
//                         ctx.textAlign = 'center';
//                         ctx.font = fontStyle + ' ' + fontSize + 'px' + ' ' + fontFamily;
//                         ctx.fillStyle = fontColor;
//                         ctx.fillText(value, x, y - radius - fontSize);
//                         ctx.restore();
//                     });
//                 });
//             }
//          }]
//     });

//     var scrolled = false;

//     $(window).scroll(() => {
//         if (isScrolledIntoView() && !scrolled){
//           runAnimation();
//           scrolled = true;
//         }
//     });

//     $(window).ready(() =>{
//         if (isScrolledIntoView() && !scrolled){
//             runAnimation();
//             scrolled = true;
//         }
//     })



//     function isScrolledIntoView(){
//         var docViewTop = $(window).scrollTop();
//         var docViewBottom = docViewTop + $(window).height();

//         var elemTop = $('#ctx').offset().top;
//         var elemBottom = elemTop + $('#ctx').height();

//         return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
//     }


//     function runAnimation(){
//         var interval = setInterval(animateLine, 10);
//         var i = 0;
//         var dataIndex = 0;

//         function animateLine(){
//             i += 4;
//             var gradient = ctx.createLinearGradient(i, 0, i+1, 0);
//             gradient.addColorStop(1, 'rgba(45,175,230,0)');
//             gradient.addColorStop(0, 'rgba(45,175,230,1)');   
//             myChart.data.datasets.forEach( (dataset, index) =>{
//                 dataset.borderColor = [gradient];
//                 var datasetMeta = myChart.getDatasetMeta(index);
//                 var canva = myChart.ctx;
//                 if(datasetMeta.data[dataIndex].x < i){
//                     var value = dataset.data[index],
//                         x = datasetMeta.data[dataIndex].getCenterPoint().x,
//                         y = datasetMeta.data[dataIndex].getCenterPoint().y,
//                         radius = datasetMeta.data[dataIndex].options.radius,
//                         fontSize = (window.matchMedia("(max-width: 570px)").matches) ? 8 : 14,
//                         fontFamily = 'Verdana',
//                         fontColor = 'black',
//                         fontStyle = 'normal';
//                     canva.save();
//                     canva.textBaseline = 'middle';
//                     canva.textAlign = 'center';
//                     canva.font = fontStyle + ' ' + fontSize + 'px' + ' ' + fontFamily;
//                     canva.fillStyle = fontColor;
//                     canva.fillText(value, x, y - radius - fontSize);
//                     canva.restore();
//                     dataIndex += 1;
//                     myChart.update();
//                 }
//             })
//             myChart.update();
//             Chart.defaults.plugins.tooltip.enabled = false;
//             if(i > window.screen.width){
//                 clearInterval(interval);
//             }
//         }
//     }
//     }
// }